function normalizePluginId(value = '') {
  return String(value || '').trim();
}

function cloneJsonLike(value) {
  if (Array.isArray(value)) return value.map((item) => cloneJsonLike(item));
  if (!value || typeof value !== 'object') return value;
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [key, cloneJsonLike(item)])
  );
}

function cloneManifest(manifest = {}) {
  if (!manifest || typeof manifest !== 'object') return null;
  return cloneJsonLike(manifest);
}

export function createDeclaredPluginAccess({ getPluginItems, loadPluginModule } = {}) {
  const readItems = typeof getPluginItems === 'function'
    ? getPluginItems
    : () => [];
  const loadModule = typeof loadPluginModule === 'function'
    ? loadPluginModule
    : null;

  function findDeclared(pluginId = '') {
    const normalizedId = normalizePluginId(pluginId);
    if (!normalizedId) return null;
    const items = readItems();
    if (!Array.isArray(items)) return null;
    return items.find((item) => normalizePluginId(item?.manifest?.id) === normalizedId) || null;
  }

  return Object.freeze({
    isDeclared(pluginId = '') {
      return Boolean(findDeclared(pluginId));
    },

    getManifest(pluginId = '') {
      const entry = findDeclared(pluginId);
      return entry ? cloneManifest(entry.manifest) : null;
    },

    async load(pluginId = '') {
      const normalizedId = normalizePluginId(pluginId);
      const entry = findDeclared(normalizedId);
      if (!entry) {
        const error = new Error(`Plugin '${normalizedId || '(empty)'}' is not declared by the active app.`);
        error.code = 'PLUGIN_NOT_DECLARED';
        throw error;
      }
      if (!loadModule) {
        const error = new Error(`Plugin loader is unavailable for '${normalizedId}'.`);
        error.code = 'PLUGIN_LOADER_UNAVAILABLE';
        throw error;
      }
      return loadModule(entry);
    }
  });
}
